export { default } from "./LayoutLandingPagesHeader";
export type { LayoutLandingPagesHeaderProps } from "./LayoutLandingPagesHeader";
